/* ──────────────────────────────────────────────────────────────
 *  SOR API — upload & parse SOR Excel files
 * ────────────────────────────────────────────────────────────── */

import axiosClient from './axiosClient';
import type { SORParseResult } from '@/types/sor';

/** Upload an SOR Excel file and receive parsed fields + targets. */
export async function parseSOR(file: File): Promise<SORParseResult> {
  const form = new FormData();
  form.append('file', file);

  const { data } = await axiosClient.post<SORParseResult>(
    '/sor/parse',
    form,
    {
      // Do NOT set Content-Type manually — Axios auto-sets it with
      // the correct multipart boundary when given a FormData body.
      timeout: 30_000,
    },
  );
  return data;
}
